var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择触发条件"},on:{"change":_vm.onChage},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}},[_c('el-option',{attrs:{"label":"全部条件","value":null}}),_vm._l((_vm.list),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.key}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }